export function normalizeEmail(email) {
    return email.trim().toLowerCase();
}

export function normalizePhoneNumber(phone) {
    // Example assumes phone number is already in E.164 format.
    return phone.replace(/[^+0-9]/g, '');
}
